import React from "react";
import { Link } from "react-router-dom";

const WorkItems = ({item}) => {
    return (
        <div className="work-card" key={item.id}>
            <img src={item.image} alt="" className="work-img" />
            <div className="work-labels">
                <span className="work-label work-label--category" data-category={item.category}>
                    {item.category === "ui/ux" ? "UI/UX" : item.category === "branding" ? "Brand" : item.category === "website" ? "Website" : item.category.charAt(0).toUpperCase() + item.category.slice(1)}
                </span>
            </div>
            <h3 className="work-title">{item.title}</h3>
            <Link to={`/project/${item.id}`} className="work-button">
                Lihat Lebih Lanjut <i className='bx bx-right-arrow-alt work-button-icon'></i>
            </Link>
        </div>
    )
}

export default WorkItems;